// assets/preview-upload.js
// Shared preview-image upload for the custom product builders.
// Takes an ALREADY-RENDERED canvas; never participates in drawing.
// Returns a Promise<string> that NEVER rejects: on any failure it resolves the
// deterministic CDN URL anyway (best-effort) so add-to-cart is never blocked.
(function () {
  var ENDPOINT = "/apps/garage/preview"; // App Proxy → dattum-erp
  var TIMEOUT_MS = 8000;
  var CDN_BASE = "https://tso.co/cdn/shop/files/";

  // name: deterministic filename WITH extension, e.g. "TSO1-TSO2-P.jpg"
  window.tsoUploadPreview = function (canvas, name) {
    return new Promise(function (resolve) {
      var deterministicUrl =
        CDN_BASE + name + "?v=" +
        Math.floor(1000000000 + Math.random() * 9000000000);

      if (!canvas || typeof canvas.toBlob !== "function") {
        console.warn("[preview-upload] no canvas; using deterministic URL");
        return resolve(deterministicUrl);
      }

      canvas.toBlob(function (blob) {
        // 1. Dedup: if the file already exists, reuse it (no upload).
        // HEAD, not GET — existence check shouldn't download the image
        $.ajax({ url: deterministicUrl, method: "HEAD", timeout: TIMEOUT_MS })
          .done(function () { resolve(deterministicUrl); })
          .fail(function () {
            if (!(blob instanceof Blob)) {
              console.warn("[preview-upload] blob invalid; deterministic URL");
              return resolve(deterministicUrl);
            }
            // 2. Upload via our App Proxy endpoint.
            var form = new FormData();
            form.append("image", blob, name);
            form.append("name", name.replace(/\.jpg$/, ""));
            $.ajax({
              url: ENDPOINT,
              method: "POST",
              data: form,
              processData: false,
              contentType: false,
              timeout: TIMEOUT_MS,
            })
              .done(function (response) {
                var resp = response;
                try { if (typeof response === "string") resp = JSON.parse(response); }
                catch (e) { resp = null; }
                resolve((resp && resp.url) ? resp.url : deterministicUrl);
              })
              .fail(function () {
                console.warn("[preview-upload] endpoint failed; deterministic URL");
                resolve(deterministicUrl); // non-blocking
              });
          });
      }, "image/png");
    });
  };
})();
